import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import * as ConfigPHSService from './../services/configPHSService';
import { SAGA_DELAY_TIMEOUT } from '../constants/Define';
import i18n from '../constants/initLng';

import * as ConfigPHSAction from '../actions/configPHSAction';

function* getConfigPHS() {
    yield takeLatest(Types.GET_CONFIG_PHS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(ConfigPHSService.getConfigPHS);
        yield put(ConfigPHSAction.setConfigPHS(result));
    }, errorHandleRole(Types.CONFIG_PHS_FAIL)))
}

function* updateConfigPHS() {
    yield takeLatest(Types.CONFIG_PHS_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ConfigPHSService.updateConfigPHS, action.phs);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.GET_CONFIG_PHS_ACTION })
    }, errorHandleRole(Types.CONFIG_PHS_FAIL)))
}

function errorHandleRole(errorActionType) {
    return Func.sagaErrorHandler(function* (e){
        yield put({ type: errorActionType })
    }, 'configPHS');
}

export function* configPHSSaga() {
    yield all([
        fork(getConfigPHS),
        fork(updateConfigPHS),
    ])
}
